/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

// TODO : https://product-fabric.atlassian.net/browse/DSP-3537

import React from 'react';

export function SlackIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0)">
				<path
					d="M5.53305 15.1364C5.53305 16.5215 4.40159 17.6529 3.01653 17.6529C1.63146 17.6529 0.5 16.5215 0.5 15.1364C0.5 13.7513 1.63146 12.6199 3.01653 12.6199H5.53305V15.1364Z"
					fill="#E01E5A"
				/>
				<path
					d="M6.7998 15.1373C6.7998 13.7522 7.93127 12.6207 9.31633 12.6207C10.7014 12.6207 11.8329 13.7522 11.8329 15.1373V21.4383C11.8329 22.8234 10.7014 23.9548 9.31633 23.9548C7.93127 23.9548 6.7998 22.8234 6.7998 21.4383V15.1373Z"
					fill="#E01E5A"
				/>
				<path
					d="M9.31633 5.03305C7.93127 5.03305 6.7998 3.90159 6.7998 2.51653C6.7998 1.13146 7.93127 0 9.31633 0C10.7014 0 11.8329 1.13146 11.8329 2.51653V5.03305H9.31633Z"
					fill="#36C5F0"
				/>
				<path
					d="M9.3176 6.30078C10.7027 6.30078 11.8341 7.43224 11.8341 8.81731C11.8341 10.2024 10.7027 11.3338 9.3176 11.3338H3.01653C1.63146 11.3338 0.5 10.2024 0.5 8.81731C0.5 7.43224 1.63146 6.30078 3.01653 6.30078H9.3176Z"
					fill="#36C5F0"
				/>
				<path
					d="M19.4219 8.81731C19.4219 7.43224 20.5533 6.30078 21.9384 6.30078C23.3235 6.30078 24.4549 7.43224 24.4549 8.81731C24.4549 10.2024 23.3235 11.3338 21.9384 11.3338H19.4219V8.81731Z"
					fill="#2EB67D"
				/>
				<path
					d="M18.1517 8.8176C18.1517 10.2027 17.0202 11.3341 15.6352 11.3341C14.2501 11.3341 13.1187 10.2027 13.1187 8.8176V2.51653C13.1187 1.13146 14.2501 0 15.6352 0C17.0202 0 18.1517 1.13146 18.1517 2.51653V8.8176Z"
					fill="#2EB67D"
				/>
				<path
					d="M15.6371 18.9215C17.0222 18.9215 18.1537 20.053 18.1537 21.438C18.1537 22.8231 17.0222 23.9546 15.6371 23.9546C14.2521 23.9546 13.1206 22.8231 13.1206 21.438V18.9215H15.6371Z"
					fill="#ECB22E"
				/>
				<path
					d="M15.6366 17.6529C14.2516 17.6529 13.1201 16.5215 13.1201 15.1364C13.1201 13.7513 14.2516 12.6199 15.6366 12.6199H21.9377C23.3228 12.6199 24.4542 13.7513 24.4542 15.1364C24.4542 16.5215 23.3228 17.6529 21.9377 17.6529H15.6366Z"
					fill="#ECB22E"
				/>
			</g>
			<defs>
				<clipPath id="clip0">
					<rect width="24" height="23.9999" fill="white" transform="translate(0.5)" />
				</clipPath>
			</defs>
		</svg>
	);
}
